import Vue from 'vue'
import Vuex from 'vuex'

import { auth } from './auth.module'
import { users } from './user.module'
import { customers } from './customer.module'
import { resellers } from './reseller.module'
import { licenses } from './license.module'
import { systemSettings } from './system-settings.module'
import { userSettings } from './user-settings.module'
import { meta } from './meta.module'
import { dev } from './dev.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    loading: false
  },
  modules: {
    auth,
    users,
    customers,
    resellers,
    licenses,
    systemSettings,
    userSettings,
    meta,
    dev
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js